import React, { useState, useContext } from "react";
import Plot from "react-plotly.js";
import { GlobalContext } from "../../App";
import { Rnd } from "react-rnd";

export default function VectorDataChart() {
  const {
    chartCollapse,
    setCollapse,
    setOpenGeojSonGraph,
    xProperty,
    yProperty,
    xValues,
    yValues,
  } = useContext(GlobalContext);
  const [size, setSize] = useState({ width: 600, height: 400 });
  const [plotType, setPlotType] = useState("bar");

  const chartData =
    plotType === "bar"
      ? [
          {
            type: "bar",
            x: xValues,
            y: yValues,
            marker: { color: "darkcyan" },
          },
        ]
      : [
          {
            type: "pie",
            labels: xValues,
            values: yValues,
            textinfo: "label+percent",
            insidetextorientation: "radial",
          },
        ];

  const chartLayout =
    plotType === "bar"
      ? {
          autosize: true,
          title: `${xProperty} vs ${yProperty}`,
          xaxis: { title: xProperty || "X-Axis" },
          yaxis: { title: yProperty || "Y-Axis" },
        }
      : {
          autosize: true,
          title: `Pie chart of ${xProperty || "Data"}`,
        };

  return (
    <div
      className="chatbot-section-container"
      style={{ cursor: "nwse-resize" }}
    >
      <Rnd
        size={{ width: size.width, height: size.height }}
        onResize={(e, direction, ref) => {
          setSize({
            width: parseInt(ref.style.width),
            height: parseInt(ref.style.height),
          });
        }}
        onResizeStop={(e, direction, ref) => {
          setSize({
            width: parseInt(ref.style.width),
            height: parseInt(ref.style.height),
          });
        }}
        default={{
          x: 20,
          y: -350,
          width: 600,
          height: 400,
        }}
        minWidth={600}
        minHeight={400}
        maxWidth={950}
        maxHeight={750}
        disableDragging={false}
        bounds="window"
      >
        <div style={{ width: "100%", height: "100%" }}>
          <Plot
            data={chartData}
            layout={chartLayout}
            config={{ responsive: true }}
            style={{
              width: "100%",
              height: "100%",
              boxShadow: "5px 0px 10px 0px #383838",
            }}
            useResizeHandler={true}
          />
        </div>

        {/* Close Button */}
        <div
          style={{
            position: "absolute",
            top: chartCollapse ? "0px" : "5px",
            left: "5px",
          }}
        >
          <button
            title="close"
            className="btn"
            onClick={() => setOpenGeojSonGraph(false)}
            style={{
              color: "white",
              backgroundColor: "#397AA5",
              fontSize: chartCollapse ? "10px" : "15px",
              padding: "2px 2px",
              width: chartCollapse ? "20px" : "30px",
              height: chartCollapse ? "20px" : "30px",
              borderRadius: "10%",
            }}
          >
            &times;
          </button>
          <select
            value={plotType}
            onChange={(e) => setPlotType(e.target.value)}
            style={{
              padding: "5px",
              borderRadius: "5px",
              fontSize: "12px",
              backgroundColor: "#397AA5",
              color: "white",
              border: "none",
            }}
          >
            <option value="bar">Bar Chart</option>
            <option value="pie">Pie Chart</option>
          </select>
        </div>
      </Rnd>
    </div>
  );
}